/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateOrganizationPolicySettingRequestOrganizationPolicySettingFromJSON(json) {
    return UpdateOrganizationPolicySettingRequestOrganizationPolicySettingFromJSONTyped(json, false);
}
export function UpdateOrganizationPolicySettingRequestOrganizationPolicySettingFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        label: !exists(json, 'label') ? undefined : json['label'],
        url: !exists(json, 'url') ? undefined : json['url']
    };
}
export function UpdateOrganizationPolicySettingRequestOrganizationPolicySettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        label: value.label,
        url: value.url
    };
}
